import './header';
import './home';
import './footer';
import './product_detail';
import './product_list';

/* Dark and Light theme system */
/*function createTheme() {
    document.body.setAttribute('data-theme', localStorage.getItem('data-theme'));
    if (document.body.getAttribute('data-theme') == undefined) {
        document.body.setAttribute('data-theme', 'light')
        localStorage.setItem('data-theme', 'light')
    } else document.body.setAttribute('data-theme', localStorage.getItem('data-theme'));
}

createTheme();*/

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
    const dataSrc = elemento.getAttribute('data-src');
    if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
    }
});

(function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var $el = $(el);
      if ($el.visible(true)) {
        $el.addClass("widget-loaded");
        $el.children().trigger("mouseenter");

        setTimeout(() => {
          const domEl = el;
          const appendColors = domEl.querySelector('.product-item__content--figure');
          const colorsVariation = domEl.querySelector('.product-item__options');

          if (appendColors && colorsVariation) {
            appendColors.appendChild(colorsVariation);
          }
        }, 1000);

        $el.on("click", "input[id^='product_item_variation__product_detail']", function () {
          var input = $(this);
          var inputId = input.attr("id");
          var label = $el.find("label[for='" + inputId + "']");

          if (label.length && !label.hasClass("out-of-stock")) {
            setTimeout(function () {
              $el.find(".js-button-add-product-to-cart__product-list").trigger("click");
            }, 500);
          }
        });
      }
    });
  }

  // Adicionar mais eventos para melhor compatibilidade mobile
  $(window).on('scroll mousemove touchstart touchmove touchend', function () {
    loadWidgets();
  });

  // Adicionar evento específico para quando a página terminar de carregar
  $(document).ready(function () {
    loadWidgets();
  });

  const observerFastBuyPopup = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === "class") {
        const target = mutation.target;
        if (target.classList.contains("active")) {
          const elementsToRemove = target.querySelectorAll(".product-item__content--figure .product-item__options");
          elementsToRemove.forEach(el => el.remove());
        }
      }
    });
  });
  document.querySelectorAll(".shoppub-fast-buy-popup").forEach(popup => {
    observerFastBuyPopup.observe(popup, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });